import { Link } from '@cbhq/cds-web/typography';

export default {
  '1': {
    title: 'Name that product',
    question: (
      <span>
        What CDP product is the subject of this{' '}
        <Link
          underline={false}
          href="https://www.youtube.com/watch?v=zn3p1hFYhp8&list=PL0zEUTVaoPOwCBVzFA1dEdN2fIwtCjmcQ&index=17"
        >
          AMA video
        </Link>
        ?
      </span>
    ),
    hint: (
      <>
        See{' '}
        <Link href="https://www.youtube.com/watch?v=P0py9gATYBA&list=PL0zEUTVaoPOwCBVzFA1dEdN2fIwtCjmcQ&index=12">
          YouTube
        </Link>
        .
      </>
    ),
  },
  '2': {
    title: 'Name that product',
    question: 'What product would you use to sponsor gas for users?',
    hint: (
      <Link href="https://docs.cdp.coinbase.com/cdp-apis/docs/welcome" underline={false}>
        https://docs.cdp.coinbase.com/cdp-apis/docs/welcome
      </Link>
    ),
  },
  '3': {
    title: 'Base Agent',
    question:
      'Create a Base Agent and tell the Agent to send 0.1 Base Sepolia ETH to an address of your choosing. Post a screenshot of the successful transaction in Discord and share the link here.',
    hint: '',
  },
  '4': {
    title: 'Autonomous Agent',
    question:
      'Create a Base Agent and use it in auto (2) or two-agent (3) mode. Post a screenshot of what you see on X with #CDPQuest and share a link to your post here.',
    hint: '',
  },
  '5': {
    question: (
      <>
        Fork & clone the{' '}
        <Link underline={false} to="https://github.com/coinbase/onchain-app-template">
          OnchainKit template
        </Link>
        . Share a link to your Github repo.
      </>
    ),
    hint: '',
  },
  '6': {
    question:
      'Add the Checkout component to your OnchainKit template. Post a screenshot of your component with #CDPQuest and share a link to your post here.',
    hint: '',
  },
  '7': {
    title: 'Final Quest',
    question:
      'Build an app using at least 3 different components from our CDP SDK or OnchainKit and share on X or our Discord.',
    hint: 'Use Cursor to help you build your app by downloading the CDP SDK docs as a markdown attaching that to your Cursor project.',
  },
};
